/**
 * NB Event Queue JS | Event
 *
 * @copyright 2023 NB Communication Ltd
 *
 */

import data from '../config.json';
import { base64Encode, clearStorage, eq, getKey, getOpen, getTimestamp, gtagEvent, isActive, getNow } from '../js/_func.js';

function nbEventQueue() {

	data.open = + new Date(data.open);
	data.close = + new Date(data.close);
	data.ts = getNow(); // Current timestamp

	// Redirect to the queue
	const redirect = type => {

		// Store the entry timestamp for later use
		localStorage.setItem(getKey('in'), base64Encode(data.ts));

		// Log event
		gtagEvent({ redirect: type });

		// Redirect
		window.location.href = `${data.queue}?session=${base64Encode(JSON.stringify(data))}`;
	};

	// Validate a token
	const validate = token => eq('validate', {
		id: data.id,
		open: data.open,
		close: data.close,
		ts: getTimestamp('in'),
		token: token
	}, result => {

		if (result.status === 200 && result.response === true) {

			// If valid, store
			localStorage.setItem(getKey('token'), token);

		} else {

			// If token likely generated in the window, display an 'invalid' alert before redirecting
			if (getTimestamp('in') > getOpen(data)) {
				gtagEvent({ invalid: `${data.id},${data.open},${data.close},${getTimestamp('in')},${token}` });
				alert('Sorry, your access token is invalid. Redirecting you to the queue...');
			}

			// If not valid
			// Remove any stored values
			clearStorage(['token', 'in']);

			// Redirect to the queue
			redirect(2);
		}
	});

	if (window.location.search.indexOf('reset=1') > -1) {
		clearStorage(['token', 'in']);
		data.reset = 1;
	}

	if (isActive(data, data.ts)) {

		// If we are in the queue window

		const token = localStorage.getItem(getKey('token'));
		if (token) {
			// If there is an access token stored, check it
			validate(token);
		} else if (window.location.search.indexOf('token=') > -1) {
			// If there is an access token passed, check it
			validate(window.location.search.replace(/\?token=(.*?)$/, '$1'));
		} else {
			// Redirect to the queue
			redirect(1);
		}

	} else if ((window.location.origin + window.location.pathname) === data.entry) {

		// If queue closed, redirect to the homepage or the event if the window has passed.
		window.location.href = data[data.ts < data.open ? 'home' : 'event'];
	}
}

document.addEventListener('DOMContentLoaded', nbEventQueue);
